import * as React from 'react';

import modelServiceInstance from 'src/services/models/ModelService';

import './FoundInModels.scss';
import Paginator from 'src/components/common/Paginator';
import ModelsLoading from './components/ModelsLoading';

import {
  ifLoggedIn,
  goToModelDetail,
  modelDetailUrl
} from 'src/utils/navigation';
import { breakpoints } from '../../utils/responsiveHelpers';
import { modelActions } from 'src/store/modules/model';

interface IFoundInModelsState {
  models: string[];
  currentModels: string[];
  searchText: string;
  activePage: number;
  loading: boolean;
  isMobile: boolean;
}

interface IFoundInModelsProps {
  partNumber: string;
  modelsQty: number;
  handleClose: () => void;
  t?: any;
}

class FoundInModels extends React.Component<
  IFoundInModelsProps,
  IFoundInModelsState
> {
  constructor(props: any) {
    super(props);

    this.state = {
      models: [],
      currentModels: [],
      searchText: '',
      activePage: 1,
      loading: true,
      isMobile: this.isMobile()
    };
  }

  private handleSearchInputChange = (e: any) => {
    this.setState({ searchText: e.target.value });
  };

  private handleSearchModelChange = () => {
    const results = this.state.models.filter(model =>
      model.toLowerCase().includes(this.state.searchText.toLowerCase())
    );
    this.setState({ currentModels: results });
  };

  private handleOnPageChange = (pageNumber: number) => {
    this.setState({ activePage: pageNumber });
  };

  private goToModel = (model: string, manufacturer: string) => {
    ifLoggedIn(() => goToModelDetail(model, manufacturer));
  };

  private renderModelsOnPage = () => {
    const { t } = this.props;
    if (this.state.currentModels.length > 0) {
      let sliced = [];
      if (this.state.isMobile) {
        sliced = this.state.currentModels;
      } else {
        sliced = this.state.currentModels.slice(
          this.state.activePage * 55 - 55,
          this.state.activePage * 55
        );
      }
      return sliced.map((model, i) => (
        <a
          key={i}
          className="link"
          href={modelDetailUrl(model, '')}
          onClick={e => this.goToModel(model, '')}
        >
          {model}
        </a>
      ));
    } else {
      return <div>{t('modelsPage.noModelsFoundWithName')}</div>;
    }
  };

  public componentDidMount() {
    modelServiceInstance
      .getPartModels(this.props.partNumber, this.props.modelsQty)
      .then(res =>
        this.setState({ models: res, currentModels: res, loading: false })
      );
  }

  public componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  public componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  public isMobile = (): boolean => {
    return window.innerWidth <= breakpoints.medium;
  };

  public handleWindowSizeChange = () => {
    const isMobile = this.isMobile();
    if (isMobile !== this.state.isMobile) {
      this.setState({ isMobile });
    }
  };

  public render() {
    const { t } = this.props;
    return (
      <div className="rp-found-in-models">
        <span
          onClick={e => this.props.handleClose()}
          className="rpds-close rp-found-in-models--close-modal-icon"
        />
        <div className="rp-found-in-models--data-container">
          <div className="rp-found-in-models--search-input-container">
            <div className="rp-found-in-models--search">
              <label className="rp-found-in-models--search-text">
                {`${t('product.foundIn')} ${this.props.modelsQty} ${t(
                  'product.models'
                )}`}
              </label>
              <div className="rp-found-in-models--search-input-container">
                <input
                  className="rp-found-in-models--search-input"
                  placeholder={t('common.searchByKeyword')}
                  onChange={this.handleSearchInputChange}
                />
                <button
                  className="primary-button rp-found-in-models--search-button"
                  onClick={this.handleSearchModelChange}
                >
                  <span className="rpds rpds-search" />
                  <label>{t('common.search')}</label>
                </button>
              </div>
            </div>
          </div>
          <div className="rp-found-in-models-data">
            {this.state.models.length > 0 ? (
              this.renderModelsOnPage()
            ) : this.state.loading ? (
              <ModelsLoading />
            ) : (
              <div className="rp-found-in-models-no-data">
                {t('modelsPage.noModelFound')}
              </div>
            )}
          </div>
        </div>
        <Paginator
          activePage={this.state.activePage}
          totalPages={Math.round(this.state.currentModels.length / 55)}
          totalItems={this.state.currentModels.length}
          itemsPerPage={55}
          onPageChanged={this.handleOnPageChange}
        />
      </div>
    );
  }
}

export default FoundInModels;
